import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Dashboard from "./Dashboard";
import { useGetMediaTypesQuery } from "../../actions/surveyActions";

const MEDIA_TYPE_IDS = {
  AUDIO: 1,
  PHOTO: 2,
  VIDEO: 3,
};

const RequestStart = ({ location }) => {
  const [disabled, setDisabled] = useState(true);
  const { request } = location.state || {};

  const { data: mediaTypesResponse, isLoading: mediaTypesLoading } =
    useGetMediaTypesQuery();

  const mediaTypeNames = useMemo(() => {
    return (mediaTypesResponse?.data || []).reduce((lookup, mediaType) => {
      lookup[mediaType.id] = mediaType.value;
      return lookup;
    }, {});
  }, [mediaTypesResponse]);

  const mediaTypeLabel = mediaTypeNames[request?.mediaType] || "Media";

  const requestName = request?.name || request?.requestName || "Media request";

  const hasInstructions = Boolean(request?.instructions?.trim());

  const hasLink = Boolean(request?.link?.trim());

  const requestMediaType = Number(request?.mediaType);

  const requestPageByMediaType = {
    [MEDIA_TYPE_IDS.PHOTO]: "/requestPhoto",
    [MEDIA_TYPE_IDS.VIDEO]: "/requestVideo",
    [MEDIA_TYPE_IDS.AUDIO]: "/requestAudio",
  };

  const requestPath = requestPageByMediaType[requestMediaType];

  return (
    <div>
      <Dashboard />

      <div className="modal">
        <Link
          to="/dashboard"
          className="modal-bg w-inline-block"
          style={{ backdropFilter: "blur(16px)" }}
        />

        <div className="padding-6 background-color-3 radius-large box-shadow-large width-full max-width-xl">
          <div className="modal-section">
            <h3 className="text-color-4 margin-0">{requestName}</h3>

            {request?.description && (
              <p className="margin-top-2">{request.description}</p>
            )}

            {hasInstructions && (
              <>
                <h5 className="text-color-4 margin-top-10">Instructions</h5>

                <div className="w-richtext">
                  <ul>
                    <li>{request.instructions}</li>
                  </ul>
                </div>
              </>
            )}

            {hasLink && (
              <div className="div-block-7">
                <p>
                  <a
                    href={request.link}
                    target="_blank"
                    rel="noreferrer"
                    className="text-color-1"
                  >
                    Open link
                  </a>

                  <svg
                    style={{
                      width: "16px",
                      height: "16px",
                      marginLeft: "4px",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-external-link icon text-color-1 _16px"
                    aria-hidden="true"
                  >
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                    <polyline points="15 3 21 3 21 9" />
                    <line x1="10" y1="14" x2="21" y2="3" />
                  </svg>
                </p>
              </div>
            )}

            <h5 className="text-color-4 margin-top-10">Details</h5>

            <p>
              Payout is{" "}
              <span className="text-color-1">
                {request?.versusCreditsAccruing} Scout Credits
              </span>
            </p>

            <p>
              Accepted media:{" "}
              <span className="text-color-1">
                {mediaTypesLoading ? "Loading..." : mediaTypeLabel}
              </span>
            </p>

            <div className="padding-top-6 margin-top-6 border-top-2px flex-space-between flex-align-center portrait-flex-column portrait-flex-align-start">
              <div className="w-form">
                <form id="terms-form" name="terms-form" data-name="Terms Form">
                  <label className="w-checkbox">
                    <input
                      type="checkbox"
                      id="terms-checkbox"
                      name="terms-checkbox"
                      className="w-checkbox-input"
                      onChange={(event) => setDisabled(!event.target.checked)}
                    />

                    <span className="w-form-label">
                      I agree to the&nbsp;
                      <a
                        href="https://doc.versus.africa/versus/terms-and-conditions-versus-scouts"
                        target="_blank"
                        rel="noreferrer"
                        className="text-color-4 underline"
                      >
                        terms
                      </a>{" "}
                      &amp;&nbsp;
                      <a
                        href="https://doc.versus.africa/versus/privacy-policy"
                        target="_blank"
                        rel="noreferrer"
                        className="text-color-4 underline"
                      >
                        privacy policy
                      </a>
                    </span>
                  </label>
                </form>
              </div>

              {requestPath ? (
                <Link
                  to={{
                    pathname: requestPath,
                    state: { request },
                  }}
                >
                  <button
                    type="button"
                    disabled={disabled || mediaTypesLoading}
                    className="button-secondary w-button"
                  >
                    Begin
                  </button>
                </Link>
              ) : (
                <p className="text-color-2">Unsupported media type.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestStart;
